import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth/withWidth";

import ForwardArrow from "@material-ui/icons/ArrowForward";
import BackwardArrow from "@material-ui/icons/ArrowBack";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { Bar } from "react-chartjs-2";
import {
  Button,
  ButtonGroup,
  Card,
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  IconButton,
  Paper,
  MenuItem,
  ListItemText,
  ListItemSecondaryAction,
  Menu,
} from "@material-ui/core";
import { getPollData, getGraphData } from "./utils";
import {
  amber,
  cyan,
  blue,
  purple,
  orange,
  teal,
  lime,
  brown,
} from "@material-ui/core/colors";

const shade = 200;
const colors = [
  amber[shade],
  cyan[shade],
  blue[shade],
  purple[shade],
  orange[shade],
  teal[shade],
  lime[shade],
  brown[shade],
];

const styles = (theme) => ({
  card: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  bar: {
    height: 320,
  },
  votebuttons: {
    paddingLeft: "10px",
  },
  pollText: {
    paddingLeft: 41.5,
    paddingRight: 41.5,
  },
  pollTextMobile: {
    paddingLeft: 15,
    paddingRight: 35,
  },

  listItem0: { backgroundColor: colors[0] + "!important" },
  listItem1: { backgroundColor: colors[1] + "!important" },
  listItem2: { backgroundColor: colors[2] + "!important" },
  listItem3: { backgroundColor: colors[3] + "!important" },
  listItem4: { backgroundColor: colors[4] + "!important" },
  listItem5: { backgroundColor: colors[5] + "!important" },
  listItem6: { backgroundColor: colors[6] + "!important" },
  listItem7: { backgroundColor: colors[7] + "!important" },
});

function InstructorHoverPoll(props) {
  let mobile = props.width === "sm" || props.width === "xs";
  const [categoryAnchorEl, setCategoryAnchorEl] = React.useState(null);
  const [optionsConfig, setOptionsConfig] = React.useState([]);
  const [categoryName, setCategoryName] = React.useState(null);

  let voteButtons = (fullWidth) => (
    <ButtonGroup fullWidth={fullWidth} className={props.classes.votebuttons}>
      {["A", "B", "C", "D", "E"].map((choice) => (
        <Button
          key={choice}
          color={props.poll.answer === choice ? "primary" : "default"}
          variant={props.poll.answer === choice ? "contained" : "outlined"}
          onClick={() => {
            props.poll.answer === choice
              ? props.setAnswer(props.poll.pollID, "")
              : props.setAnswer(props.poll.pollID, choice);
          }}
        >
          {choice}
        </Button>
      ))}
    </ButtonGroup>
  );

  // Handles button clicks when in minimized controls mode poll display
  const handlePollChangeButtons = (index) => {
    if (props.polls) {
      const newIndexPollID = Object.values(props.polls).find(
        (poll) => poll.pollIndex === index
      ).pollID;

      props.setShowDisplayInactive(true, newIndexPollID);
    }
  };

  return (
    <>
      {props.poll ? (
        <>
          <Card className={props.classes.card} elevation={0}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              style={{ marginTop: 60, gap: 10 }}
            >
              <Typography
                className={
                  mobile ? props.classes.pollTextMobile : props.classes.pollText
                }
              >
                Poll: {props.poll.pollIndex ?? "No Poll"}
              </Typography>
              <Button
                onClick={() => {
                  handlePollChangeButtons(props.poll.pollIndex - 1);
                }}
                disabled={props.poll.pollIndex === 1}
              >
                <BackwardArrow />
              </Button>
              <Button
                onClick={() => {
                  handlePollChangeButtons(props.poll.pollIndex + 1);
                }}
                disabled={props.poll.pollIndex === props.pollsLength}
              >
                <ForwardArrow />
              </Button>
              <Button
                onClick={() => {
                  handlePollChangeButtons(props.pollsLength);
                }}
                disabled={props.poll.pollIndex === props.pollsLength}
              >
                Current Poll
              </Button>
            </Box>

            <Grid
              style={{
                marginTop: optionsConfig.length > 0 ? 0 : 40,
                marginBottom: optionsConfig.length > 0 ? 4 : 0,
              }}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={0}
            >
              {optionsConfig.map((option, index) => {
                let listItemStyle = "listItem" + option.index;
                return (
                  <Grid item key={index}>
                    <List style={{ padding: 0 }}>
                      <ListItem
                        classes={{ selected: props.classes[listItemStyle] }}
                        dense
                        button
                        selected={option.checked}
                        onClick={() => {
                          let newOptionsConfig = optionsConfig.slice();
                          newOptionsConfig[index].checked = !option.checked;
                          setOptionsConfig(newOptionsConfig);
                        }}
                      >
                        <ListItemText primary={option.optionName} />
                        <ListItemSecondaryAction>
                          <IconButton
                            style={{ padding: 8 }}
                            edge="end"
                            onClick={() => {
                              let newOptionsConfig = optionsConfig.slice();
                              newOptionsConfig[index].checked = !option.checked;
                              setOptionsConfig(newOptionsConfig);
                            }}
                          >
                            {option.checked ? <RemoveIcon /> : <AddIcon />}
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    </List>{" "}
                  </Grid>
                );
              })}
            </Grid>

            <Grid container spacing={1}>
              <Grid item md={12} xs={12}>
                <Paper className={props.classes.bar} elevation={0}>
                  <Bar
                    data={getGraphData(
                      getPollData(
                        props.poll.students,
                        categoryName,
                        props.poll.pollCategories[categoryName]
                      ),
                      props.poll,
                      categoryName,
                      optionsConfig
                    )}
                    redraw={true}
                    options={{
                      maintainAspectRatio: false,
                      animation: false,
                      scales: {
                        xAxes: [
                          {
                            stacked: true,
                          },
                        ],
                        yAxes: [
                          {
                            stacked: true,
                            suggestedMin: 0,
                            ticks: {
                              min: 0,
                              max: 100,
                              callback: (value) => value + "%",
                            },
                          },
                        ],
                      },
                    }}
                    legend={{ display: false }}
                  />
                </Paper>
              </Grid>
              <Button
                fullWidth
                variant="outlined"
                onClick={(event) => {
                  setCategoryAnchorEl(event.currentTarget);
                }}
              >
                {!categoryName ? "Category" : categoryName}
              </Button>
              <ListItem>{voteButtons(true)}</ListItem>
            </Grid>
          </Card>

          <Menu
            id="category-menu"
            anchorEl={categoryAnchorEl}
            open={Boolean(categoryAnchorEl)}
            onClose={() => {
              setCategoryAnchorEl(null);
            }}
          >
            <MenuItem
              button={true}
              key="None"
              onClick={() => {
                setCategoryAnchorEl(null);
                setCategoryName(null);
                setOptionsConfig([]);
              }}
            >
              None
            </MenuItem>

            {Object.keys(props.poll.pollCategories).map((categoryName) => (
              <MenuItem
                button={true}
                key={categoryName}
                onClick={() => {
                  let optionNames = props.poll.pollCategories[categoryName];

                  let newOptionsConfig = [];
                  optionNames
                    .concat(["Unknown"])
                    .forEach((optionName, index) => {
                      newOptionsConfig.push({
                        optionName: optionName,
                        checked: true,
                        index: index,
                      });
                    });

                  setCategoryAnchorEl(null);
                  setCategoryName(categoryName);
                  setOptionsConfig(newOptionsConfig);
                }}
              >
                {categoryName}
              </MenuItem>
            ))}
          </Menu>
        </>
      ) : null}
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(InstructorHoverPoll))
  )
);
